
import isEmpty from 'lodash/isEmpty'

export const HIGHLIGHTED_PICKERS_VARIANTS = {
  info: 'info',
  accent: 'accent',
}
export const ANIMATION_TYPE = {
  UNDEFINED: undefined,
  PRICE_ROLLING_UP: 'price-rolling-up',
  PRICE_ROLLING_DOWN: 'price-rolling-down',
}
export default {
  props: {
    price: {
      type: Object,
      required: true,
    },
    priceStyle: {
      type: String,
      default: '',
    },
    priceType: {
      type: String,
      default: '',
    },
    hasAnimation: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      prevPrice: null,
      prevPriceStyle: '',
      priceChange: undefined,
    }
  },
  computed: {
    showNormalPrice() {
      return this.priceChange === undefined
    },
    priceRollingUp() {
      return this.priceChange === ANIMATION_TYPE.PRICE_ROLLING_UP
    },
    priceRollingDown() {
      return this.priceChange === ANIMATION_TYPE.PRICE_ROLLING_DOWN
    },
  },
  watch: {
    price(newValue, oldValue) {
      if (!this.hasAnimation) {
        return
      }

      const isAccent = this.priceType === HIGHLIGHTED_PICKERS_VARIANTS.accent
      const isInfo = this.priceType === HIGHLIGHTED_PICKERS_VARIANTS.info

      this.prevPrice = oldValue

      if (isAccent && !isEmpty(this.prevPrice)) {
        this.priceChange = ANIMATION_TYPE.PRICE_ROLLING_UP
      } else if (isInfo && !isEmpty(this.prevPrice)) {
        this.priceChange = ANIMATION_TYPE.PRICE_ROLLING_DOWN
      } else {
        this.priceChange = undefined
      }
    },
    priceStyle(newValue, oldValue) {
      this.prevPriceStyle = oldValue
    },
  },
}
